import { StoreWithUniqueKey } from '../../../../../app/layout/StoreSelectionState';
import { StoreSelectorTranslation } from '../../../../../app/localization/SiteTranslation';
import StoreFlag from '../../../StoreFlag';
import css from './StoreSelector.css';

interface StoreSelectorProps {
  currentStoreKey: string;
  items: StoreWithUniqueKey[];
  translation: StoreSelectorTranslation;
  onSelect: (store: StoreWithUniqueKey) => void;
}

export default function StoreSelector({ currentStoreKey, items, translation, onSelect }: StoreSelectorProps) {
  return (
    <section>
      <h3 className={css.heading}>{translation.title}</h3>
      <ul className={css.items}>
        {items.map((store) => (
          <li key={store.key}>
            <button
              type="button"
              className={css.button}
              aria-current={store.key === currentStoreKey}
              onClick={() => onSelect(store)}
            >
              <StoreFlag className={css.flag} storeId={store.id} />
              {store.name}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
